export const GeneralLang = {
  toastClose: 'Close',
};
